const v = {
  name: "Company",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M5,0h30v6h-2v32h7v2h-7v0H7v0H0v-2h7V6H5V0z M31,6H9v4h22V6z M9,12v4h22v-4H9z M9,18v4h22v-4H9z M9,28h22v-4
			H9V28z M9,30v8h4v-8H9z M15,30v8h4v-8H15z M21,30v8h4v-8H21z M27,30v8h4v-8H27z M7,4h26V2H7V4z"/>
	</g>
</g>
</svg>
  `
};
export {
  v as Company
};
